import axios from 'axios'
import router from '@/router'
import type { AxiosResponse } from 'axios'
//import { useCache } from '@/composables/Cache';

export interface ApiObject<T>{
  data : T
}

export interface ApiResponse<T> extends AxiosResponse<ApiObject<T>> {
  //data: { data : T }
  //status: number
  message?: string
}

export class ApiError extends Error{
    constructor(message : string){
    super(message);
    this.name="ApiError";
    }
}


const api =  axios.create({
  baseURL: '/api',
  headers: {
    'apikey' : '7bnbRrv8hWvS1kCGcxH89'
    //'apikey' : process.env.API_KEY
  }
  //baseURL: '127.0.0.1:8080/api' //behind nginx
  //baseURL: '127.0.0.1:3000',
});

api.interceptors.response.use((response : ApiResponse<Object>)  => {
  console.log("..axios interceptor on response...");
 // console.log("...response = ")
 // console.log(JSON.stringify(response));
  if(response.status === 400){
    console.log("....400 response received..." + JSON.stringify(response));
   // throw new ApiError(JSON.stringify(JSON.stringify(response)));
    throw new ApiError(response.message || 'Error with Api');
  }else{
    return response;
  }

}, error =>{
  if(error.response.status === 401 || error.response.status === 403){
    console.log(" axios intercepted response code 401 or 403...");
    router.push('/restricted');
  }else if(error.response.status === 498){
    //user's session expired
    console.log("user session has expired, log back in")
    router.push('/login');

  }else if(error.response.status === 400){
    throw new ApiError(JSON.stringify(error));
  }else{
    throw new ApiError('API ERROR : ' + JSON.stringify(error.response.data.message)); ///error.response.message);
  }
})

/**
 * Wrapper for axios post
 * @param url 
 *
function apiPost(url : string, obj : any){
 const request = new Request(`https://api/${url}`);
      //const request = 'https://api/customers';
      //const req = '/customers';
      //const response = await axios.get('/customers');
      const cached = await cache.exists(request);
      if(!cached){
          const response = await axios.get('/customers');
          await cache.clearCache();
          //const body = { headers: {'content-type': 'application/json'}};
          const body = "teststring";
          //const myBlob = new Blob();
          const myOptions = { status: 200, statusText: "SuperSmashingGreat!" };
          const myResponse = new Response(body, myOptions);
          //const fakeResponse = new Response(body);
          const responseObj = await cache.convertToResponseLike(response);
          //console.log("...myResponse = " + await myResponse.text());
          await cache.addResourceToCache(request, responseObj);
          //await cache.addResourceToCache(request, fakeResponse);
      
      }



  api
        .post(url, obj)
        .then((res) => {
          alert.success(res.data.message)
          setTimeout(() => {
            alert.clear()
            fetchAllCustomers()
            router.back()
          }, 3000)
        })
        .catch((error) => {
          if (error.response) {
            alert.error(error.response.data)
          } else if (error.request) {
            alert.error(error.request)
          }
        })
}*/


export default api;




